// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.food_sensory_question_type */
var FoodSensoryQuestionType;
(function (FoodSensoryQuestionType) {
    FoodSensoryQuestionType["scale"] = "scale";
    FoodSensoryQuestionType["short_text"] = "short_text";
    FoodSensoryQuestionType["paragraph"] = "paragraph";
    FoodSensoryQuestionType["single_choice"] = "single_choice";
    FoodSensoryQuestionType["multi_choice"] = "multi_choice";
    FoodSensoryQuestionType["yes_no"] = "yes_no";
    FoodSensoryQuestionType["sample_pick"] = "sample_pick";
    FoodSensoryQuestionType["sample_rank"] = "sample_rank";
})(FoodSensoryQuestionType || (FoodSensoryQuestionType = {}));
;
export default FoodSensoryQuestionType;
/** Zod schema for food_sensory_question_type */
export const foodSensoryQuestionType = z.nativeEnum(FoodSensoryQuestionType);
//# sourceMappingURL=FoodSensoryQuestionType.js.map